import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { BreadCrumb, BreadCrumbProp } from '../../../../components/light/Breadcrumb';
import { Content } from '../../../../components/light/Content';
import { SectionBlock } from '../../../../components/light/SectionBlock';
import { Loading } from '../../../../components/Loading';

const QUERY = gql`
  query merchantSponsorDetail($id: Int){
  merchantSponsorDetail(campaign_id: $id){
    itemId
    code
    supplierCode
    picture
    impression
    remaining
  }
}`;

const QUERY_PRODUCT = gql`
query merchantProductViewDate($from: String!, $to: String!, $itemID: [Int]){
	merchantProductViewDate(from: $from, to: $to, itemsID: $itemID)
}
`;

export function SponsorDetailScreen(){
  const { params }: any = useRouteMatch();
  const [totalClick, setTotalClick ] = useState(0);
  const [totalSale, setTotalSale] = useState(0);
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: 'no-cache',
    variables: {
      id: Number(params.id)
    }
  });
  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: 'Applications',
      to: '#'
    },
    {
      text: 'Products',
      to: '#'
    },
    {
      text: 'Sponsor Product',
      to: '/sponsor/list'
    },
    {
      text: params.id,
      to: '/sponsor/detail/' + params.id
    }
  ];
  
  if(data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-10">
            <SectionBlock title={"Sponsor Item"} transparent={true}>
              <Loading />
            </SectionBlock>
          </div>
        </div>
      </Content>
    )
  }

  return(
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems}/>}>
      <div className="row">
        <div className="col-md-10">
          <SectionBlock title={"Sponsor Item"} transparent={true}>
            <table className="table table-padded">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Impression</th>
                  <th>Remaining</th>
                  <th className="text-center">Click</th>
                  <th className="text-center">Sale</th>
                </tr>
              </thead>
              <tbody>
                {
                  data.merchantSponsorDetail.map((x: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td>
                          <span
                            style={{
                              display: "inline-flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={x.picture}
                              alt=""
                              style={{
                                width: 45,
                                boxShadow:
                                  "0 1px 1px 0 #00000033, 0 2px 2px 0 #00000030",
                                borderRadius: 3,
                              }}
                            />
                            <span
                              className="text-left"
                              style={{ marginLeft: 10 }}
                            >
                              <label>{x.itemId}</label>
                              <br />
                              <Link
                                to={
                                  "https://www.l192.com/product/" + x.itemId
                                }
                                target="_blank"
                              >
                                L192: {x.code}
                              </Link>
                            </span>
                          </span>
                        </td>
                        <td className="text-left">{x.impression}</td>
                        <td className="text-left">{x.remaining}</td>
                        <ClickViewItem 
                          itemid={Number(x.itemId)} 
                          onCompleted={val => {
                            setTotalClick(totalClick + val.count_click);
                            setTotalSale(totalSale + val.sale_click);
                          }}
                        />
                      </tr>
                    )
                  })
                }
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-center text-success">{totalClick}</td>
                  <td className="text-center text-success">${totalSale}</td>
                </tr>
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  )
}

function ClickViewItem({ itemid, onCompleted }: { itemid: number, onCompleted: (e: any) => void}){
  const query = new URLSearchParams(window.location.search);
  const [state, setState] = useState({
    sale_click: 0,
    count_click: 0
  })
  const {data, loading} = useQuery(QUERY_PRODUCT, {
    fetchPolicy: 'no-cache',
    variables: {
      from: query.get('from'),
      to: query.get('to'),
      itemID: [itemid]
    },
    onCompleted: res => {
      let count_click = 0;
      let sale_click = 0;
      for(const y of res.merchantProductViewDate) {
        count_click += y.Clicked;
        sale_click += y.Sales;
      }
      setState({
        sale_click,
        count_click
      });
      onCompleted({
        sale_click,
        count_click
      })
    }
  });

  if (loading || data === undefined) return (
    <>
      <td className="text-center text-success"><Loading /></td>
      <td className="text-center text-success"><Loading /></td>
    </>
  )

  return(
    <>
      <td className="text-center text-success">{state.count_click}</td>
      <td className="text-center text-success">${state.sale_click}</td>
    </>
  )
}